import { useContext } from "react";

import { TApiButtonCommandFn } from ".";

import { DynamicFormContext } from "containers/DynamicForm/DynamicFormContext";
import { useAppDispatch } from "store/index";

import { compact } from "lodash-es";

import { useGroupApi } from "../useGroupApi";

export const useExecuteGroupApi = () => {
  const dispatch = useAppDispatch();
  const { mutationResponses } = useContext(DynamicFormContext);
  const apiGroupThunk = useGroupApi();

  const executeGroupApiCommand: TApiButtonCommandFn = async commandArgs => {
    try {
      const commandArguments = commandArgs || [];
      // Create an array of thunks for each Group API command
      const groupApiThunks = compact(
        commandArguments.map(argument => apiGroupThunk(argument.source))
      );

      // Dispatch each thunk and wait for all promises to resolve
      const dispatchedThunks = groupApiThunks.map(async thunk => {
        const thunkAction = dispatch(thunk);
        const mutationKey = thunkAction.arg.mutationKey;

        return {
          [mutationKey]: await thunkAction.unwrap(),
        };
      });
      const groupApiResponse = await Promise.all(dispatchedThunks);

      // Store all responses into the mutationResponses context
      groupApiResponse.forEach(response => {
        mutationResponses.current = {
          ...mutationResponses.current,
          ...response,
        };
      });

      return groupApiResponse;
    } catch (error) {
      throw error;
    }
  };

  return executeGroupApiCommand;
};
